import { useHttp } from '../http'

export const useAppContentHttp = () => {

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`app-contents`, payload)
    }

    const patch = <T>(payload: any): Promise<T> => {
        return useHttp().patch(`app-contents`, payload)
    }

    return {
        get,
        patch
    }
}
